const jewelryList = [
  {
    jID: 1,
    price: 100,
    image: 'https://www.starweddingring.co.uk/images/star-wedding-rings-9ct-yellow-gold-heavy-court-shape-6mm-wedding-ring-p279-1553_image.jpg',
    Name: 'Gold Ring',
    Desc: 'A beautiful gold ring with intricate designs.'
  },
  {
    jID: 2,
    price: 250,
    image: 'https://assets.angara.com/pendant/lsp0108d/5.1mm-fgvs-lab-grown-diamond-s999-silver-pendant.jpg?width=940&quality=95&width=768&quality=95',
    Name: 'Diamond Necklace',
    Desc: 'A stunning diamond necklace that sparkles in the light.'
  },
  {
    jID: 3,
    price: 75,
    image: 'N/A',
    Name: 'Silver Bracelet',
    Desc: 'A simple yet elegant silver bracelet perfect for everyday wear.'
  },
  {
    jID: 4,
    price: 180,
    image: 'https://www.thefinejewellerycompany.com/media/catalog/product/cache/1/image/9df78eab33525d08d6e5fb8d27136e95/i/m/img_2d_0001_10_88.jpg',
    Name: 'Pearl Earrings',
    Desc: 'Classic pearl earrings that add a touch of sophistication.'
  },
  {
    jID: 5,
    price: 300,
    image: 'https://veda.jewelry/wp-content/uploads/2019/10/emerald-lg-gold-1280x1600.jpg',
    Name: 'Emerald Pendant',
    Desc: 'An exquisite emerald pendant that captures the essence of luxury.'
  },
  {
    jID: 6,
    price: 120,
    image: 'https://www.maxdiamonds.co.uk/wp-content/uploads/2018/01/engagement-ring-35.jpg',
    Name: 'Ruby Ring',
    Desc: 'A striking ruby ring that stands out with its vibrant color.'
  },
  {
    jID: 7,
    price: 90,
    image: 'https://a.1stdibscdn.com/oscar-heyman-305-carats-sapphire-diamond-platinum-flower-wreath-brooch-for-sale/j_11843/j_147015921644314112739/j_14701592_1644314113450_bg_processed.jpg?disable=upscale&auto=webp&quality=60&width=960',
    Name: 'Sapphire Brooch',
    Desc: 'A beautiful sapphire brooch that adds elegance to any outfit.'
  },
  {
    jID: 8,
    price: 150,
    image: 'https://i.etsystatic.com/7360072/r/il/d9b094/3328886322/il_1588xN.3328886322_6std.jpg',
    Name: 'Topaz Anklet',
    Desc: 'A delicate topaz anklet perfect for summer wear.'
  },
  {
    jID: 9,
    price: 200,
    image: 'https://i.etsystatic.com/24321605/r/il/50420b/2609853463/il_1588xN.2609853463_8zwt.jpg',
    Name: 'Amethyst Cufflinks',
    Desc: 'Stylish amethyst cufflinks that add a pop of color to formal attire.'
  },
  {
    jID: 10,
    price: 110,
    image: 'https://i.etsystatic.com/27766534/r/il/81261b/2983862009/il_fullxfull.2983862009_1efl.jpg',
    Name: 'Citrine Pendant',
    Desc: 'A radiant citrine pendant that brings warmth and brightness.'
  }
];

export default jewelryList;